import Vue from 'vue';
import VueAMap from 'vue-amap';
import Viser from 'viser-vue';
import App from './App.vue';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import './registerServiceWorker';
import './plugins/ant-design-vue';
import './components/index';
import './plugins/directive';
import './plugins/filter';
import './permission';
import router from './router';
import store from './store';

Vue.use(Viser);
Vue.use(VueAMap);
Vue.use(VueViewer);
VueAMap.initAMapApiLoader({
  key: '1cc4534f215bcd631e6426ea3cb7c233',
  plugin: [
    'Autocomplete',
    'AMap.ToolBar',
    'AMap.Scale',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Geocoder',
    'AMap.MouseTool',
    'PlaceSearch',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'PolyEditor',
    'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
});
Vue.config.productionTip = false;

const APP = new Vue({
  router,
  store,
  render: (h) => h(App),
});
window.APP = APP;
APP.$mount('#app');
